import { NextLink } from 'components/blocks/NextLink';
import { useMemo, useRef } from 'react';
import { SanitizeMode, useSanitizedHtmlProps } from 'util/sanitized';
import { useVisibilityWindow } from 'util/useVisibilityWindow';
import { useQueryWithInitialValue } from 'util/useQueryWithInitialValue';
import { IRegionFeaturedResort, IRegionShort } from 'api/region/types';
import { fetchRegionFeatured } from 'api/region/static';
import { IResortPageInfo } from 'api/resort/types';
import { Routes } from 'routes';
import { useBrandfolderOptimizedImage } from 'util/useBrandfolderOptimizedImage';
import styles from './styles.module.scss';

export const Region = ({
  region,
  isFresh,
}: {
  region: IRegionShort,
  isFresh: boolean,
}) => {
  const { current } = useQueryWithInitialValue(['region-fetchRegionFeatured', region.uuid],
    async () => fetchRegionFeatured(region.uuid),
    {} as IRegionFeaturedResort);

  const curResort = useMemo(() => {
    if (!current?.details) {
      return {} as IResortPageInfo;
    }

    return current.details;
  }, [current]);

  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);
  const title = useSanitizedHtmlProps(region.title || '', SanitizeMode.TextOnly);
  const image = (isFresh && isVisible) ? (curResort.image) : '';
  const optimizedImage = useBrandfolderOptimizedImage(image);
  const style = optimizedImage ? { backgroundImage: `url(${optimizedImage})`, backgroundSize: 'cover' } : { };

  return (
    <div className={styles.box} ref={ref}>
      <NextLink href={Routes.regionSnowReport(region)} data-click-id="related">
        <figure style={style} tabIndex={-1} />
        <div className={styles.footer}>
          {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
          <span {...title} className={styles.title} />
        </div>
      </NextLink>
    </div>
  );
};
